import initVideo from './components/video-modal';
import initCollectors from './components/email-collector';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown/index';
import 'jquery-sticky/jquery.sticky';

// Initialise video modal
initVideo();

DetachedDropdown.createAll(
    '[data-detached-dropdown]:not([data-categories-menu-detached-dropdown])',
    {}
);

// Initialise email collection boxes
initCollectors();

$('[data-social-media-links]').sticky({
    className: 'social-media-links-sticky',
});
